import { GeoMap } from './GeoMap';
import { RadiusSelector } from './RadiusSelector';
import { faBuilding, faHospital } from '@fortawesome/free-regular-svg-icons'
const MarkerTypes = {
    Hospital: 'hospital',
    Clinic: 'clinic'
};

export class UsersNearMeMap extends GeoMap
{

    constructor ()
    {
        super();

        this.infoWindow = null;
        this.radiusSelector = null;
    }

    connectedCallback()
    {
        this.#init();
    }

    getMapID()
    {
        return 'users-near-me-map';
    }

    #init()
    {
        this.markers = [];
        this.initMap().then((map) => {
            this.createRadiusSelector();
            this.initLegend();
            this.initZipCodeLocator();
            this.initEventHandlers();

            setTimeout(() => {
                this.redrawLocalUsers();
            }, 1000);
        });
    }

    createRadiusSelector()
    {
        // RadiusSelector.js will automatically be loaded into memory when this dom object is inserted into the document.
        // See https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_custom_elements
        this.radiusSelector = document.body.appendChild(document.createElement('geomap-radius-selector'));
        this.radiusSelector.init(this.map);
    }

    initEventHandlers ()
    {
        super.initEventHandlers();

        this.onClickMarker = this.onClickMarker.bind(this);
        this.redrawLocalUsers = this.redrawLocalUsers.bind(this);
        document.addEventListener('geomap-radius-selector-change-event', this.redrawLocalUsers);
        document.addEventListener('geomap-zipcode-locator-change-event', this.redrawLocalUsers);
        this.map.addListener('dragend', this.redrawLocalUsers);
    }

    onClickMarker(event, latLng, marker, facility)
    {
        if (this.infoWindow) {
            this.infoWindow.close();
        }

        const content = `
<div class='info-window-content'>
    <h5>${facility.ClinicName}</h5>
    <ul>
        <label>Address:</label> 
        <ul class="address">
            ${facility.Address1 ? '<li>' + facility.Address1 + '</li>' : ''}
            ${facility.Address2 ? '<li>' + facility.Address2 + '</li>' : ''}
            ${facility.City ? '<li>' + facility.City + ', ' : ''} ${facility.State ? facility.State : ''}  ${facility.Zip ? facility.Zip + '</li>' : '</li>'}
        </ul>
        ${facility.OfficePhone ? '<li><label>Office Phone:</label> ' + facility.OfficePhone + '</li>' : ''}
        ${facility.FaxPhone ? '<li><label>Fax Phone:</label> ' + facility.FaxPhone + '</li>' : ''}
        ${facility.EmailAddress ? '<li><label>Email:</label> ' + facility.EmailAddress + '</li>' : ''}
    </ul>
</div>
`;
        this.infoWindow = new google.maps.InfoWindow({
            content: content,
            ariaLabel: facility.ClinicName
        });

        this.infoWindow.open({
            anchor: marker,
            map: this.map
        });
    }

    async createMarker(facility)
    {
        let markerType = MarkerTypes.Clinic;
        if (facility['IsSpecHospitalClinic'] == 1) {
            markerType = MarkerTypes.Hospital;
        }

        let markerIcon = false;
        switch(markerType) {
            case MarkerTypes.Clinic:
                markerIcon = faBuilding;
                break;

            case MarkerTypes.Hospital:
                markerIcon = faHospital;
                break;
        }

        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker"); // as google.maps.MarkerLibrary;
        const pinSVG = this.createSvgElement(markerIcon);

        const advancedMarker = new AdvancedMarkerElement({
            map: this.map,
            position: { lat: parseFloat(facility.latitude), lng: parseFloat(facility.longitude) },
            content: pinSVG,
            title: facility.ClinicName
        });

        // advancedMarker.set('id', facilityID);
        this.markers.push(advancedMarker);
        advancedMarker.addListener('click', (event, latLng) => {
            this.onClickMarker(event, latLng,advancedMarker, facility);
        });

        return advancedMarker;
    }

    createSvgElement(markerIcon)
    {
        const pinSvgString = '<svg xmlns="http://www.w3.org/2000/svg" ' +
            'width="50" ' +
            'height="30" ' +
            'viewBox="0 0 560 560" ' +
            'fill="none">' +
            '<rect ' +
            'width="300" ' +
            'height="100" ' +
            'rx="28" ' +
            'fill="none"></rect>' +
            '<path d="' + markerIcon.icon[4] + '" ' +
            'stroke="red" ' +
            'stroke-width="2.5" ' +
            'stroke-linecap="round" ' +
            'stroke-linejoin="round" ' +
            'fill="red"></path></svg>';

        const parser = new DOMParser();
        const pinSVG = parser.parseFromString(pinSvgString, 'image/svg+xml').documentElement;

        return pinSVG;
    }

    retrieveVetologyUsers()
    {
        return new Promise((resolve, reject) => {
            fetch('/users-near-me/retrieve-facilities', {

            }).then(response => {
                if (response.ok) {
                    response.json().then(json => {

                    });
                } else {

                }
            })
        });
    }


    redrawLocalUsers()
    {
        const km = this.radiusSelector.getRadius();

        const center = this.map.getCenter();
        const formData = new FormData();
        formData.append('latitude', center.lat());
        formData.append('longitude', center.lng());
        formData.append('kmRadius', km);
        const queryString = new URLSearchParams(formData);

        fetch('/users-near-me/nearby-facilities?' + queryString.toString(), {
            method: 'get',
            headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
            }
        }).then(response => {
            if (!response.ok) {
                toastr.error('Could not retrieve local users at this time.  Please try later');
            } else {
                response.json().then(json => {
                   if (!json.success) {
                       toastr.error(json.message);
                   }  else {
                       this.clearMarkers();
                       json.facilities.forEach(facility => {
                           const marker = this.createMarker(facility);
                       });
                   }
                });
            }
        });
    }

    clearMarkers()
    {
        this.markers.forEach((marker, idx, object) => {
           marker.setMap(null);
        });
        this.markers = [];
    }
    initLegend()
    {
        const legend = this.createLegend();
        this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(legend);
    }

    createLegend()
    {
        const legend = document.createElement('div');
        legend.setAttribute('id', 'map-legend');
        // this.after(legend);
        const header = legend.appendChild(document.createElement('h4'));
        header.classList.add('legend-header');
        header.textContent = 'Legend';
        const iconList = legend.appendChild(document.createElement('ul'));
        iconList.classList.add('legend-list');
        let li = iconList.appendChild(document.createElement('li'));
        li.appendChild(this.createSvgElement(faBuilding));
        let itemLabel = li.appendChild(document.createElement('span'));
        itemLabel.textContent = 'Clinic';

        li = iconList.appendChild(document.createElement('li'));
        li.appendChild(this.createSvgElement(faHospital));
        itemLabel = li.appendChild(document.createElement('span'));
        itemLabel.textContent = 'Hospital';

        return legend;
    }

    initZipCodeLocator()
    {
        // ZipCodeLocator.js will automatically be loaded into memory when this dom object is inserted into the document.
        // See https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_custom_elements
        this.zipCodeLocator = document.body.appendChild(document.createElement('geomap-zipcode-locator'));
        this.zipCodeLocator.init(this.map);

    }

 }

customElements.define('users-near-me-map', UsersNearMeMap);